const getResponseKey = (props = {}) => {
  const { responseDataType } = props;

  if (responseDataType === 'collection') {
    return 'responseCollection';
  } else if (responseDataType === 'numeric') {
    return 'responseNumeric';
  } else if (responseDataType === 'boolean') {
    return 'responseState';
  } else if (responseDataType === 'binary') {
    return 'responseBinary';
  } else if (responseDataType === 'datetime') {
    return 'responseDateTime';
  } else if (responseDataType === 'string') {
    return 'responseString';
  }

  return '';
};

export default getResponseKey;



// WEBPACK FOOTER //
// ./src/qoc-sdk/utils/getResponseKey.js